export const PROMO = 'promoList';
